/**
 * @generated SignedSource<<5fb454e9bc18917939b215ab7464b480>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeaturedDealStatus = "CLOSED" | "DRAFT" | "PENDING" | "PUBLISHED";
export type mutationsToggleDraftFeaturedDealMutation$variables = {
  id: string;
};
export type mutationsToggleDraftFeaturedDealMutation$data = {
  readonly toggleDraftFeaturedDeal: {
    readonly featuredDeal: {
      readonly id: string;
      readonly status: FeaturedDealStatus;
    } | null;
  } | null;
};
export type mutationsToggleDraftFeaturedDealMutation = {
  response: mutationsToggleDraftFeaturedDealMutation$data;
  variables: mutationsToggleDraftFeaturedDealMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ToggleDraftFeaturedDealMutation",
    "kind": "LinkedField",
    "name": "toggleDraftFeaturedDeal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FeaturedDealNode",
        "kind": "LinkedField",
        "name": "featuredDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsToggleDraftFeaturedDealMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mutationsToggleDraftFeaturedDealMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e655dc67de3f878612f465a07ea30ee7",
    "id": null,
    "metadata": {},
    "name": "mutationsToggleDraftFeaturedDealMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsToggleDraftFeaturedDealMutation(\n  $id: ID!\n) {\n  toggleDraftFeaturedDeal(id: $id) {\n    featuredDeal {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d9d15bdc58a06f80ba4da5554d7c5aba";

export default node;
